module.exports = __webpack_public_path__ + "img/header-3.c17d1524.jpg";